/**
* Full Width Image Callout JS
* -----------------------------------------------------------------------------
*
* All the JS for the Full Width Image Callout component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'full-width-image-callout',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const query = window.matchMedia( '(prefers-reduced-motion: reduce)' );
      if ( !query.matches ) {
        $( '.full-width-image-callout__image' ).each( function() {
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top 70%',
              pin: false,
              scrub: 1,
            },
          } );
          tl.fromTo( $( this ), {scale: 1.15}, {scale: 1} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'full-width-image-callout', COMPONENT );
} )( app );
